module.exports = __webpack_public_path__ + "img/OCB.3bc4c66e.svg";